/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import SimpleTooltip from '../../simple-tooltip';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

interface ColumnFlagsProps extends ColumnCommonProps {
  verificationRequired: boolean;
  evidenceRequired: boolean;
  noteRequired?: boolean
}

export const ColumnFlags = (props: ColumnFlagsProps) => {
  const { question, verificationRequired, evidenceRequired, noteRequired } = props;

  const isEvidenceRequired = !!question?.utrv?.evidenceRequired;
  const isVerificationRequired = !!question?.utrv?.verificationRequired;
  const isNoteRequired = !!question?.utrv?.noteRequired;

  const icons = [];

  if (evidenceRequired !== isEvidenceRequired) {
    const action = isEvidenceRequired ? 'required' : 'optional';
    icons.push({ className: 'fa fa-file mx-1', tooltip: `Evidence ${action}` });
  }

  if (verificationRequired !== isVerificationRequired) {
    const action = isVerificationRequired ? 'required' : 'optional';
    icons.push({ className: 'fa fa-user-edit mx-1', tooltip: `Verification ${action}` });
  }

  if (noteRequired !== isNoteRequired) {
    const action = isNoteRequired ? 'required' : 'optional';
    icons.push({ className: 'fa-solid fa-note mx-1', tooltip: `Explanation ${action}` });
  }

  if (icons.length === 0) {
    return null;
  }

  return (
    <Column className={'flagsCol text-ThemeTextPlaceholder'}>
      {icons.map(icon => <SimpleTooltip key={icon.className} text={icon.tooltip}>
        <i className={icon.className} />
      </SimpleTooltip>)}
    </Column>
  );
}
